<template>
  <div class="container">
    <div class="card">
      <router-link :to="{ name: 'game-login' }">
        <img class="logo" src="/images/logo-font-white.svg" alt="Logo yuzu" />
      </router-link>
      <div class="block">
        <h2>{{ $t("game.connectionProblemView.title") }}</h2>
        <p>
          {{ $t("game.connectionProblemView.instructions") }}
        </p>
      </div>
      <div class="btn-group">
        <router-link :to="{ name: 'game-forgot-password' }" class="btn outline secondary">{{ $t("game.connectionProblemView.forgotPasswordButton") }}</router-link>
        <!-- Removed because we no longer have unicity of phone number
        <router-link
          :to="{ name: 'game-forgot-email' }"
          class="btn outline secondary"
          >{{ $t('game.connectionProblemView.forgotEmailButton') }}</router-link
        > -->
      </div>
      <router-link class="btn primary icon icon-left" to="" @click.prevent="router.back()"
        ><i class="bi bi-arrow-left" /><span>{{ $t("game.connectionProblemView.backButton") }}</span></router-link
      >
    </div>
  </div>
</template>

<script lang="ts" setup>
  const router = useRouter();
</script>
